module.exports = __webpack_public_path__ + "static/media/lg.ecff1170.eot";